module.exports = __webpack_public_path__ + "img/person_black_48dp.449e2686.svg";